import { createSlice } from '@reduxjs/toolkit';

import {
  createMeasurement,
  createMeasurements,
  deleteMeasurements,
  fetchAnimalMeasurements,
  fetchMeasurementTypes,
  fetchMeasurements,
  updateMeasurement
} from '../actions/measurement';

const measurementSlice = createSlice({
  name: 'measurement',
  initialState: {
    data: [],
    error: null,
    loading: false,
    sortedData: [],
    types: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Create Measurement
      .addCase(createMeasurement.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMeasurement.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMeasurement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Measurements
      .addCase(createMeasurements.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createMeasurements.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMeasurements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Measurements
      .addCase(fetchMeasurements.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMeasurements.fulfilled, (state, action) => {
        state.data = action.payload;
        state.sortedData = action.payload;
        state.loading = false;
      })
      .addCase(fetchMeasurements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Animal Measurements
      .addCase(fetchAnimalMeasurements.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnimalMeasurements.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchAnimalMeasurements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Measurement Types
      .addCase(fetchMeasurementTypes.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMeasurementTypes.fulfilled, (state, action) => {
        state.types = action.payload;
        state.loading = false;
      })
      .addCase(fetchMeasurementTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Measurement
      .addCase(updateMeasurement.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMeasurement.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMeasurement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Measurements
      .addCase(deleteMeasurements.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMeasurements.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteMeasurements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = measurementSlice.actions;
export default measurementSlice.reducer;
